import { gql } from '@efficiently/client-core-graphql-models';

export const TOGGLE_PUBLISH_STATUS = gql(`
	mutation sharePoint($contentId: String!, $permission: SharePointPermission!) {
		sharePoint(args: { contentId: $contentId, permission: $permission })
	}
`);
